import React, { type FC, useEffect } from 'react';

import { LessonGoBackLine, LingoLiftLessonFooter, LingoLiftLessonHeader, MainLayout, RelatedLessons } from '../../widgets';
import { Typography, Link } from '@mui/material';
import styles from './styles';
import {
  useGetLingoLiftStudentLessonAscDetailsQuery,
  useGetLingoLiftStudentLessonDetailsQuery,
  usePostLingoLiftStudentLessonAssignmentCompletionsMutation,
} from '../../entities/lingoLiftLesson';
import Div from '../../shared/ui/Div';
import { UserRole } from "../../entities/user";
import { ECSDKPlayer } from '../../shared/components/ECSDKPlayer';
import { CompletionState } from '../../widgets/LingoLift/ui/LingoLiftLessonFooter/types';

interface ILingoLiftLessonStudentShowProps {
  id: number;
  accessToken: string;
  partnerKey: string;
  dialogId: number;
  lessonAscId?: number;
  languageCode: string;
  seeAllLessonsLabel: string;
}

const LingoLiftLessonStudentShowPage: FC<ILingoLiftLessonStudentShowProps> = props => {
  const {
    id,
    accessToken,
    partnerKey,
    dialogId,
    lessonAscId,
    languageCode,
    seeAllLessonsLabel
  } = props;

  const { data: lessonDetails, isLoading: isDefaultLessonDetailsLoading } = useGetLingoLiftStudentLessonDetailsQuery(id);

  const { data: lessonAscDetails, isLoading: isAscLessonLoading } =
    useGetLingoLiftStudentLessonAscDetailsQuery(
      lessonAscId!,
      {
        skip: !lessonAscId,
      },
    );
  const skipLessonAscDetails = !lessonAscId;

  const [onCreateAssignmentCompletions, { data: result }] =
    usePostLingoLiftStudentLessonAssignmentCompletionsMutation();

  useEffect(() => {
    onCreateAssignmentCompletions({
      llLessonAssignmentCompletion: { llLessonId: Number(id) },
    });
  }, []);

  const isLoading = isDefaultLessonDetailsLoading || isAscLessonLoading;

  return (
    <MainLayout backgroundColor="white" userRole={UserRole.Student} isLoading={isLoading}>
    <LessonGoBackLine title={seeAllLessonsLabel} />
      {lessonDetails && (
        <>
            <LingoLiftLessonHeader
              {...lessonDetails.item}
              setOpenElpModal={() => {}}
              onToggleFavorite={() => {}}
            />
            <Div sx={styles.iframe} id="player-container" />
            {!!(lessonDetails && (lessonAscDetails || skipLessonAscDetails)) && (
              <ECSDKPlayer
                partnerKey={partnerKey}
                accessToken={accessToken}
                dialogId={dialogId}
                languageCode={languageCode}
              />
            )}
            {lessonAscDetails && (
              <LingoLiftLessonFooter
                assignmentCompletionId={result?.id}
                state={result?.state as CompletionState}
              />
            )}

            { lessonDetails?.related?.length > 0 &&  <RelatedLessons related={lessonDetails.related} /> }

            {lessonDetails?.item.enhancedCollection && (
              <Div sx={styles.collectionLinkWrapper}>
                <Typography variant="body1" component="p">
                  {'Collection: '}
                  <Link href={lessonDetails?.item.enhancedCollection.studentDetailUrl} target="_blank" rel="noopener noreferrer" sx={styles.collectionLink}>
                    {lessonDetails?.item.enhancedCollection.name}
                  </Link>
                </Typography>
              </Div>
            )}
        </>
      )}
    </MainLayout>
  );
};

export default LingoLiftLessonStudentShowPage;
